import React, { useEffect, useState } from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "../typography";
import "../sda/styles.scss";
import { Link } from "@amzn/stencil-react-components/link";
import useArb from "../../hooks/use-arb";
import {
  getLocale,
  isEnglishLocale,
  isSpanishLocale,
} from "../../utility/locale-helper";
import { USCIS_URL, USCIS_URL_ES } from "../../config/urls";
import { processTime } from "../../utility/time-processor";
import { getSettings, MX_STAGES } from "../../helpers/get-settings";

interface PreHireAppointmentDetailsProps {
  nheDate: string;
  nheTimeRange: string;
  address: string;
  supportedLanguage: string;
}
export const PreHireAppointmentDetails = ({
  nheDate,
  nheTimeRange,
  address,
  supportedLanguage,
}: PreHireAppointmentDetailsProps) => {
  const bundle = useArb("HVHChecklistPantherResource");
  const here = bundle.getMessage("Checklist-MainPage-Link");
  const uscis_link = isSpanishLocale() ? USCIS_URL_ES : USCIS_URL;

  const documentLink = (
    <Link target="_blank" href={uscis_link}>
      {here}
    </Link>
  );

  const link =
    window.location.origin +
    (isEnglishLocale()
      ? "/people-with-disabilities#/"
      : "/" + getLocale() + "/people-with-disabilities#/");
  const supportLink = (
    <Link target="_blank" href={link}>
      {here}
    </Link>
  );

  const detailTitle = bundle.getMessage("Checklist-PreHireDetails-Title");
  const venueDetails = bundle.formatMessage("Checklist-PreHireDetails-Venue", {
    address: address,
  });

  const languageDetails =
    bundle.getMessage("Checklist-AppointmentCard-Language") +
    ": " +
    supportedLanguage;
  const dateWithoutTime = new Date(nheDate);
  const dateWithTime = new Date(dateWithoutTime.getTime() + 0);

  const formattedDate = bundle.formatMessage("Checklist-PreHireDetails-Date", {
    dateTime: dateWithTime,
  });

  const startTime = nheTimeRange?.split("-")[0];
  const endTime = nheTimeRange?.split("-")[1];
  const processedStartTime = processTime(startTime);
  const processedEndTime = processTime(endTime);
  const processedStartDate = new Date(nheDate + " " + processedStartTime);
  const processedEndDate = new Date(nheDate + " " + processedEndTime);

  const message = bundle.formatMessage("Checklist-PreHireDetails-Visit", {
    startDate: processedStartDate,
    endDate: processedEndDate,
  });

  const thingsToBring = bundle.getMessage("Checklist-PreHireDetails-Things");
  const photo = bundle.getMessage("Checklist-PreHireDetails-Photo");
  const doc = bundle.getMessage("Checklist-PreHireDetails-Doc");
  const specialAssist = bundle.getMessage(
    "Checklist-PreHireDetails-Assistance"
  );
  const specialAssistDetails = bundle.formatMessage(
    "Checklist-PreHireDetails-AssistDetails",
    {
      supportLink: supportLink,
    }
  );
  const clickLink = bundle.formatMessage("Checklist-PreHireDetails-ClickLink", {
    documentLink: documentLink,
  });

  const [isMexico, setMexicoFlag] = useState<boolean>();
  useEffect(() => {
    getSettings().then((settings) =>
      setMexicoFlag(MX_STAGES.includes(settings.stage))
    );
  });

  return (
    <>
      <Col gridGap="2rem">
        <Row>
          <Col gridGap="0.5rem">
            <Text fontSize="T300">{detailTitle}</Text>
            <Text>{formattedDate}</Text>
            <Text fontSize="T100">{message}</Text>
            <Text>{venueDetails}</Text>
            {!isMexico && <Text>{languageDetails}</Text>}
          </Col>
        </Row>
        <Row>
          <Col gridGap="0.5rem">
            <Text fontSize="T300">{thingsToBring}</Text>
            <Text>{photo}</Text>
            <Text>{doc}</Text>
            <Text fontSize="T100">{clickLink}</Text>
          </Col>
        </Row>
        <Row>
          <Col gridGap="1rem">
            <Col gridGap="0.5rem">
              <Text fontSize="T300">{specialAssist}</Text>
              <Text>{specialAssistDetails}</Text>
            </Col>
          </Col>
        </Row>
      </Col>
    </>
  );
};
